export enum MODULES_ALIAS {
  accordionModule = "accordionModule",
  accordionModuleElement = "accordionModuleElement",
  accordionListModule = "accordionListModule",
  accordionListModuleElement = "accordionListModuleElement",
  audioModule = "audioModule",
  audioModuleElement = "audioModuleElement",
  blockquoteModule = "blockquoteModule",
  blockquoteModuleElement = "blockquoteModuleElement",
  cardListModule = "cardListModule",
  cardListModuleElement = "cardListModuleElement",
  cardListElement = "cardListElement",
  contactModule = "contactModule",
  contactModuleElement = "contactModuleElement",
  containerModule = "containerModule",
  containerModuleElement = "containerModuleElement",
  downloadModule = "downloadModule",
  downloadModuleElement = "downloadModuleElement",
  eventListModule = "eventListModule",
  eventListModuleElement = "eventListModuleElement",
  eventsListModule = "eventsListModule",
  eventsListModuleElement = "eventsListModuleElement",
  emailModule = "emailModule",
  emailModuleElement = "emailModuleElement",
  faqListModule = "faqListModule",
  faqListModuleElement = "faqListModuleElement",
  faqListElement = "faqListElement",
  faqModule = "faqModule",
  faqModuleElement = "faqModuleElement",
  heroModule = "heroModule",
  heroModuleElement = "heroModuleElement",
  iconModule = "iconModule",
  iconModuleElement = "iconModuleElement",
  mapModule = "mapModule",
  mapModuleElement = "mapModuleElement",
  mediaModule = "mediaModule",
  mediaModuleElement = "mediaModuleElement",
  mediaSliderModule = "mediaSliderModule",
  mediaSliderModuleElement = "mediaSliderModuleElement",
  ratingModule = "ratingModule",
  ratingModuleElement = "ratingModuleElement",
  storySliderModule = "storySliderModule",
  storySliderModuleElement = "storySliderModuleElement",
  tableModule = "tableModule",
  tableModuleElement = "tableModuleElement",
  textModule = "textModule",
  textModuleElement = "textModuleElement",
  videoEmbedModule = "videoEmbedModule",
  videoEmbedElement = "videoEmbedElement",
  smallHeroModule = "smallHeroModule",
  smallHeroModuleElement = "smallHeroModuleElement",
}

export enum CONTENT_ELEMENTS_ALIAS {
  textCard = "textCard",
  textCardElement = "textCardElement",
  imageCard = "imageCard",
  imageCardElement = "imageCardElement",
  videoCard = "videoCard",
  videoCardElement = "videoCardElement",
}

export enum FAQ_LIST_CONTENT_ELEMENT_ALIAS {
  faqItem = "faqItem",
}
export enum EVENT_LIST_CONTENT_ELEMENT_ALIAS {
  eventElement = "eventElement",
  event = "event",
}
